import Swal from 'sweetalert2';
const axios = require('axios');

export default function() {
    return new Promise((resolve, reject) => {
        const form = document.querySelector('#guest-list-lookup-form');
        if (!form) {
            Swal.fire({
                icon: 'error',
                title: 'Sorry, something has gone wrong',
                text: 'Please try refreshing the page. If the error persists, please contact an administrator',
            });
            reject();
            return;
        }

        axios({
            method: 'GET',
            url: form.getAttribute('action'),
            responseType: 'json',
        })
        .then(response => {
            // console.log('success', response);
            resolve(response.data);
        })
        .catch(error => {
            Swal.fire({
                icon: 'error',
                title: 'Sorry, something has gone wrong',
                text: 'Please try refreshing the page. If the error persists, please contact an administrator',
            });
            reject();
        })
    });
}